module.exports = __webpack_public_path__ + "img/thumbnail_MalayanTapir_f_albino.09624c14.png";